import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../models/Common';

interface InfoBlockDailyProps {
  modifier?: string;
  handleCallback: () => void;
  infoText: string;
}

const InfoBlockPrepaidOrDaily: FC<InfoBlockDailyProps> = ({ modifier = '', handleCallback, infoText }) => {
  const { t } = useTranslation();

  return (
    <div className={`payment__content__options__activation-period__info-block ${modifier || ''}`}>
      <div className="payment__content__options__activation-period__info-block__block-after">
        <p>{infoText}</p>
        <CustomMUIButton
          label={t('buttons.callback')}
          className={ButtonClassNames.PrimaryFulfilledSmall}
          handleClick={handleCallback}
          isBold
        />
      </div>
    </div>
  );
};

export default memo(InfoBlockPrepaidOrDaily);
